import { MarketingPresentationReason } from "./types";

export const NOT_AVAILABLE = "N/A" as const;

export const REQUOTE_REASONS = {
  carrierQuoteIncorrect: "Carrier Quote Incorrect",
  rfpRequestIncorrect: "RFP Request Incorrect",
  submissionDataIncorrect: "Submission Data Incorrect",
  newBrokerRequest: "New Broker Request",
  updatedRates: "Updated Rates",
  other: "Other Reason",
};

export const MARKETING_PRESENTATION_REASON_LABELS: Record<
  MarketingPresentationReason,
  string
> = {
  incorrectBenefits: "Incorrect Benefits",
  incorrectCommissions: "Incorrect Commissions",
  uncompetitiveRates: "Uncompetitive Rates",
  noLongerNeeded: "No Longer Needed",
  other: "Other Reason",
};

export const OTHER_REASON = "other" as const;
